import _ from 'lodash'

const formatNumber = (date, length) => {
	return _.padStart(date, length, '0')
}

export default formatNumber
